import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200 mb-3">
        <img
          src={movie.posterUrl}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} - 777影院高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-sm font-medium bg-primary-500/90 px-3 py-1 rounded-full whitespace-nowrap">
            立即观看
          </span>
        </div>
        {movie.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-xs font-bold px-2 py-0.5 rounded whitespace-nowrap">
            NEW
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-white text-xs font-bold px-2 py-0.5 rounded whitespace-nowrap">
            热播
          </span>
        )}
        <div className="absolute bottom-2 right-2 bg-black/70 text-accent-400 text-xs font-bold px-1.5 py-0.5 rounded whitespace-nowrap">
          {movie.rating}
        </div>
      </div>
      <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
        {movie.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{movie.englishTitle}</p>
      <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
        {movie.tags.slice(0, 2).map((tag) => (
          <span key={tag} className="text-[10px] text-secondary-600 bg-secondary-100 px-1.5 py-0.5 rounded whitespace-nowrap">
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}